import React from "react";
import { FormGroup, Label, Input, Button } from "reactstrap";
import { FaLocationArrow } from "react-icons/fa";
import CoordinateMap from "./CoordinateMap";

const CoordinateInput = ({ 
  formData, 
  handleChange, 
  handleGetCoordinates, 
  errors, 
  requiredCoordinateKecamatan 
}) => {
  // Determine which coordinate to show on map (GPS takes priority, then manual)
  const activeCoordinate = formData.titikKoordinatRumah || formData.manualTitikKoordinatRumah || "";

  // When marker is dragged, update the manual coordinate field
  const handleMapCoordinateChange = (coordString) => {
    // Simulate a change event for manualTitikKoordinatRumah
    const syntheticEvent = {
      target: {
        name: "manualTitikKoordinatRumah",
        value: coordString,
      },
    };
    handleChange(syntheticEvent);
  };

  return (
    <>
      <FormGroup>
        <Label for="titikKoordinatRumah">56. Titik Koordinat Rumah</Label>
        <Input 
          type="text" 
          name="titikKoordinatRumah" 
          id="titikKoordinatRumah" 
          value={formData.titikKoordinatRumah || ""} 
          onChange={handleChange} 
          readOnly 
        />
        <Button color="primary" onClick={handleGetCoordinates} className="btn-get-coordinates mt-2">
          <FaLocationArrow /> Ambil Koordinat
        </Button>
      </FormGroup>

      <FormGroup>
        <Label for="manualTitikKoordinatRumah">Atau Masukkan Koordinat Manual</Label>
        <Input
          type="text"
          name="manualTitikKoordinatRumah"
          id="manualTitikKoordinatRumah"
          value={formData.manualTitikKoordinatRumah || ""}
          onChange={handleChange}
          invalid={!!errors.manualTitikKoordinatRumah}
          className="form-input"
          placeholder="Contoh: -8.512345, 117.012345"
          disabled={requiredCoordinateKecamatan.includes(formData.kecamatan)} // Disable jika kecamatan termasuk Maluk/Jereweh
        />
        {errors.manualTitikKoordinatRumah && (
          <div className="invalid-feedback">{errors.manualTitikKoordinatRumah}</div>
        )}
      </FormGroup>

      {/* Leaflet Satellite Map with Draggable Marker */}
      <CoordinateMap
        coordinates={activeCoordinate}
        onCoordinateChange={handleMapCoordinateChange}
      />
    </>
  );
};

export default CoordinateInput;
